module.exports = __webpack_public_path__ + "img/handzone_sdk_logo.fec3342d.png";